import React from 'react';
import { PrimaryButton, SecondaryButton } from '../styles/SharedComponents';

interface ButtonProps {
  primary?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  fullWidth?: boolean;
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  primary = false,
  onClick,
  type = 'button',
  disabled = false,
  fullWidth = false,
  children
}) => {
  const buttonStyle = fullWidth ? { width: '100%' } : {};

  return primary ? (
    <PrimaryButton
      onClick={onClick}
      type={type}
      disabled={disabled}
      style={buttonStyle}
      whileTap={{ scale: 0.98 }}
    >
      {children}
    </PrimaryButton>
  ) : (
    <SecondaryButton
      onClick={onClick}
      type={type}
      disabled={disabled}
      style={buttonStyle}
      whileTap={{ scale: 0.98 }}
    >
      {children}
    </SecondaryButton>
  );
};

export default Button; 